import { render, staticRenderFns } from "./CourseCertificateModal.vue?vue&type=template&id=b5cf98ec&"
import script from "./CourseCertificateModal.vue?vue&type=script&lang=js&"
export * from "./CourseCertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports